import {Component, Input, OnInit} from '@angular/core';
import {MeasurementData} from "../MeasurementDataList";
import {MeasurementDescription} from "../MeasurementDescriptionList";
import {sprintf} from "sprintf-js";
import {MeasurementListComponent} from "../measurement-list/measurement-list.component";

@Component({
  selector: 'app-meting-item',
  templateUrl: './measurement-item.component.html',
  styleUrls: ['./measurement-item.component.css']
})
export class MeasurementItemComponent implements OnInit {
  @Input()
  fullChannelNumber: number = -1;
  measurementData: MeasurementData;
  measurementDescription: MeasurementDescription;
  oldStyleChannel: string = "";
  status: string = "";
  public show = false;
  public enabled = true;
  public duration = 50;
  public type = "none";
  public direction = "down";

  public get animate(): any {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }

    return false;
  }

  public onToggle(): void {
    this.show = !this.show;
  }

  public onClose(): void {
    this.show = false;
  }


  constructor(private metingenLijstComponent: MeasurementListComponent) {
    this.measurementData = new MeasurementData();
    this.measurementDescription = new MeasurementDescription();
    metingenLijstComponent.Add(this);
  }

  GetHardwareChannel(): string{
    let channelNr: number =  Math.floor( (this.fullChannelNumber) / 2 ) + 1 ;
    let channelA: string  = ((Math.floor( this.fullChannelNumber) % 2)==1) ? "A" : "-"
    this.oldStyleChannel = channelNr + channelA;
    return this.oldStyleChannel;
  }

  UpdateDescription(measurementDescription: MeasurementDescription): void
  {
    this.measurementDescription = measurementDescription;
    // let channelNr: number =  Math.floor( this.measurementDescription.channelfull-1 / 2 ) + 1;
    // let channelA: string  = ((Math.floor( this.measurementDescription.channelfull) % 2)==1) ? "A" : "-"

    //  let channelNr: number =  Math.floor( this.fullChannelNumber / 2 ) ;
    //  let channelA: string  = ((Math.floor( this.fullChannelNumber) % 2)==1) ? "A" : "-"
    //
    //
    // this.oldStyleChannel = channelNr + channelA;
  }


  GetFullChannel(): number
  {
    return this.measurementDescription.channelfull;
  }

  UpdateData(measurementData: MeasurementData): void
  {
    this.measurementData = measurementData;
    this.status = String.fromCharCode(this.measurementData.status);
  }

  GetValue():string
  {
    if(this.measurementData.measurementvalue == 4294967096)
      return "----";

    let value = this.measurementData.measurementvalue;
    if( value & 0x8000)
      value |= 0xFFFF0000;
    switch(this.measurementData.measurementprecision) {
      case 4:
        return sprintf("%2.4f", value / 10000);
      case 3:
        return sprintf("%3.3f", value / 1000);
      case 2:
        return sprintf("%4.2f", value / 100);
      case 1:
        return sprintf("%5.1f", value / 10);

      case 0:
        return sprintf("%6f", value);
      default:
        return sprintf("%f (Wrong precision)", value);
    }
  }

  ngOnInit(): void
  {
  }

}
